// Vehicle Details Action Types
export const FETCH_VEHICLE_DETAILS_REQUEST = 'FETCH_VEHICLE_DETAILS_REQUEST';
export const FETCH_VEHICLE_DETAILS_SUCCESS = 'FETCH_VEHICLE_DETAILS_SUCCESS';
export const FETCH_VEHICLE_DETAILS_FAILURE = 'FETCH_VEHICLE_DETAILS_FAILURE';

// External action types that should reset vehicle details state
export const BUY_THIS_VEHICLE = 'BUY_THIS_VEHICLE';
// Dispatched on deal refresh; the deal (and therefore the vehicle) may have changed, so reset the
// cached vehicle details to force a re-fetch instead of showing stale data.
export const FETCH_DEAL_SUCCESS = 'FETCH_DEAL_SUCCESS';
